module.exports = __webpack_public_path__ + "img/vuexy-login-bg.729bf0e4.jpg";